/* eslint-disable react/prop-types */
import { formatZIP } from "../../../../../../../../../utils/commonFunctions/ZIP";
import { Grid } from "@material-ui/core";
import "./nextHeader.css";
import { NextSectionProps } from "../../../../../../../../../@types/components/gliFormProps.types";

// eslint-disable-next-line react/prop-types
const NextSection = ({ isPrintable, employee }: NextSectionProps) => {
	const { member_id, first_name, last_name, city, address_line_1, ZIP, employee_SSN, phone_number } = employee;
	const _ZIP = formatZIP(ZIP as string);
	// console.log("Employee", employee);
	if (!first_name || !last_name || !city || !address_line_1 || !ZIP || !employee_SSN || !phone_number) return <></>;
	return (
		<>
			<div className={isPrintable ? "gli-next-header-container-print" : "gli-next-header-container"}>
				<Grid container spacing={1}>
					<Grid item xs={6} sm={6} md={6} lg={6} xl={6} className="gli-next-header display-flex">
						<div className={isPrintable ? " print-header-label font-size-sm" : "header-label"}>
							Group Policyholder Name:
						</div>
						<div className={isPrintable ? " font-size-sm " : "header-value"}>
							Brookshire Brothers Inc. (Group ID: BROOKSHIR)
						</div>
					</Grid>
					<Grid item xs={6} sm={6} md={6} lg={6} xl={6} className="gli-next-header border-right display-flex">
						<div className={isPrintable ? "print-header-label font-size-sm" : "header-label"}>
							Group Policy Number(s)
						</div>
						<div className={isPrintable ? "font-size-sm" : "header-value"}>000010251882</div>
					</Grid>
				</Grid>

				<Grid container spacing={1}>
					<Grid
						item
						xs={6}
						sm={6}
						md={6}
						lg={6}
						xl={6}
						className="gli-next-header border-bottom display-flex"
					>
						<div
							className={isPrintable ? "header-details-label-print font-size-sm" : "header-details-label"}
						>
							Employee Name and Address(Street, City, State)
						</div>
						<div className={isPrintable ? "font-size-sm" : "header-details-value"}>
							<span>{first_name}</span>
							<span style={{ marginLeft: "3px" }}>{last_name}, </span>
							<span>{address_line_1},</span>
							<span style={{ marginLeft: "2px" }}>{city},</span>
							<span style={{ marginLeft: "2px" }}>{_ZIP}</span>
						</div>
					</Grid>
					<Grid
						item
						xs={6}
						sm={6}
						md={6}
						lg={6}
						xl={6}
						className="gli-next-header border-right border-bottom  display-flex"
					>
						<div
							className={isPrintable ? "header-details-label-print font-size-sm" : "header-details-label"}
						>
							Employee ID Number
						</div>
						<div className={isPrintable ? "font-size-sm" : "header-details-value"}>
							<span>{member_id}</span>
						</div>
					</Grid>
				</Grid>
			</div>
			<div className={isPrintable ? "beneficary-section-print" : "beneficary-section"}>
				<p
					className={isPrintable ? "beneficary-paragraph font-size-sm" : "beneficary-paragraph"}
					style={{ textAlign: "justify" }}
				>
					Subject to the terms of the above numbered Group Policy(ies), I request that any sum becoming
					payable by reason of my death be payable to the following beneficiary(ies). It is my understanding
					that this designation shall operate so as to revoke all designations of beneficiary and all
					elections of optional methods of settlement previously made by me under said Policy(ies). If this
					Designation of Beneficiary refers only to a Group Life Insurance Policy and if I am also insured for
					Supplemental and/or Group Accidental Death coverage, this designation shall apply to those
					coverages. This Designation of Beneficiary is subject to all “Conditions” shown on the reverse side
					of this form.
				</p>
			</div>
		</>
	);
};

export default NextSection;
